import {
  ArrowDropDown,
  ArrowDropUp,
  DeleteOutline,
  Domain,
  EditOutlined,
  GroupAdd,
  LibraryAdd,
  Add,
} from "@mui/icons-material";
import { Box, Divider, Grid, IconButton, MenuItem, Select, TextField, Typography, Button, Collapse, Checkbox, Tab, Tooltip, CircularProgress } from "@mui/material";
import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import { color } from "../../../../StyleData/Config";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  DatePicker,
  LocalizationProvider,
  renderTimeViewClock,
  DateTimePicker,
} from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Labour from "./Labour";
import LabourBusinessCraft from "./LabourBusinessCraft";
import PartList from "./Parts";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PartEdit from "./PartEdit";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fromUTC,
  getCurrentInTimeZone,
  getDateWithOutUTC,
  toUTC,
} from "../../../../utils/dateUtil";
import ErrorProps from "../../../../Component/Errorprops";

import ResponsiveDialog from "../../../../Component/ResponsiveDialog";
const WorkPlan = ({
  workOrderId,
  jobPlanId,
  enableDisable,
  refreshEnableDisable,
}) => {
  const [taskCreate, setCreateTask] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [taskTypeList, setTaskTypeList] = useState([]);
  const [open, setOpen] = useState(false);
  const [editValue, setEditValue] = useState({});
  const [edit, setEdit] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [labour, setLabour] = useState(false);
  const [part, setPart] = useState(false);
  const [value, setValue] = useState("1");
  const [labourList, setLabourList] = useState([]);
  const [checkedDetail, setCheckedDetail] = useState([]);
  const [partList, setPartList] = useState([]);
  const [comDetail, setComDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [partEditData, setPartEditData] = useState({});
  const [partEdit, setPartEdit] = useState(false);
  const [checkBol, setCheckBol] = useState(false);
  const [source, setSource] = useState("eam");
  const [taskTypeSelect, setTaskTypeSelect] = useState("");
  const [meter, setMeter] = useState([]);
  const [multipleChoice, setMultipleChoice] = useState([]);
  const [convertDateTime, setConvertDateTime] = useState({
    targetStartDate: null,
    targetEndDate: null,
  });
  const [workCenterIdList, setWorkCenterIdList] = useState([]);
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);

  const formikRef = useRef();

  useEffect(() => {
    console.log(workOrderId, "cehcj");

    getTaskList();
    console.log(jobPlanId, "jpid");
  }, []);

  const getTaskList = async () => {
    setLoading(true);
    const taskTypeListLink = masterAPI["selectList"].taskTypes;
    await axiosPrivate
      .get(`${taskTypeListLink}`)
      .then((res) => {
        console.log(res);
        setTaskTypeList(res.data);
      })
      .catch((e) => {
        setTaskTypeList([]);
        console.log(e, "createWoTask error");
      });

    const completeDetail = masterAPI["workOrder"].completeDetail;

    await axiosPrivate
      .get(`${completeDetail}/${workOrderId}`)
      .then(async (res) => {
        console.log(res, "check");
        const sortTaskList = res.data.result.workOrderTaskList.sort(
          (a, b) => a.taskNo - b.taskNo,
        );
        setTaskData(sortTaskList);
        setLabourList(
          res.data.result.workOrderTaskLabourList.filter(
            (l) => l.isPlannedLabour === true,
          ),
        );
        setPartList(res.data.result.workOrderTaskPartsList);
        setComDetail(res.data.result);
        setWorkCenterIdList(res.data.result.workCenterIdList || []);
        //   setConvertDateTime({
        //     targetStartDate:fromUTC(res.data.result.targetStartDate)?.tzString,
        //     targetEndDate:fromUTC(res.data.result.targetEndDate)?.tzString
        //   })

        //    if (formikRef.current) {
        //   const formikCurrent = formikRef.current;
        //   formikCurrent.setFieldValue(
        //     "targetStartDate",
        //     (formikCurrent.values.targetStartDate === null&& res.data.result.targetStartDate!==null)
        //       ? fromUTC(res.data.result.targetStartDate)?.tzString
        //       : formikCurrent.values.targetStartDate,
        //   );
        //   formikCurrent.setFieldValue(
        //     "targetEndDate",
        //     formikCurrent.values.targetEndDate === null&& res.data.result.targetEndDate!==null
        //       ? fromUTC(res.data.result.targetEndDate)?.tzString
        //       : formikCurrent.values.targetEndDate,
        //   );
        // }

        const workOrderData = res.data.result;

        const assetMeter = masterAPI["meter"].getMeterByAsset;
        await axiosPrivate
          .get(`${assetMeter}/${res.data.result.assetId}`)
          .then((res) => {
            setMeter(res.data.result);
          })
          .catch((e) => {
            setMeter([]);
            console.log(e, "error");
          });
        setLoading(false);
      })
      .catch((e) => {
        setTaskData([]);
        setLabourList([]);
        setPartList([]);
        setComDetail({});
        console.log(e, "work complete details error");
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddTask = () => {
    setEdit(false);
    setMultipleChoice([]);
    setCreateTask(true);
    setEditValue({});
    setTaskTypeSelect("");
  };

  const onSubmit = async (values, { resetForm }) => {
    console.log(values, "submit value");
    setSubmitLoading(true);
    const createLink = masterAPI["workOrderTask"].create;
    const updateLink = masterAPI["workOrderTask"].update;
    if (edit) {
      const putData = {
        id: editValue.id,
        listOfChoices: multipleChoice,
        listOfSelectedChoices: multipleChoice,
        isMultipleChoice: true,
        ...values,
        taskDuration: convertToHours(values.taskDuration),
        targetStartDate: values.targetStartDate
          ? toUTC(values.targetStartDate).utcISOString
          : values.targetStartDate,
        targetEndDate: values.targetEndDate
          ? toUTC(values.targetEndDate).utcISOString
          : values.targetEndDate,
        plannedStartDate: values.plannedStartDate
          ? toUTC(values.plannedStartDate).utcISOString
          : values.plannedStartDate,
        plannedEndDate: values.plannedEndDate
          ? toUTC(values.plannedEndDate).utcISOString
          : values.plannedEndDate,
        actualStartDate: values.actualStartDate
          ? toUTC(values.actualStartDate).utcISOString
          : values.actualStartDate,
        actualEndDate: values.actualEndDate
          ? toUTC(values.actualEndDate).utcISOString
          : values.actualEndDate,
      };
      await axiosPrivate
        .put(`${updateLink}`, putData)
        .then((res) => {
          console.log(res);
          getTaskList();
          resetForm();
          setEdit(false);
          setCreateTask(false);
          setEditValue({});
          setTaskTypeSelect("");
          setMultipleChoice([]);
          setSubmitLoading(false);
        })
        .catch((e) => {
          console.log(e, "update Task");
          setSubmitLoading(false);
        });
    } else {
      const postData = {
        ...values,
        taskDuration: convertToHours(values.taskDuration),
        listOfChoices: multipleChoice,
        listOfSelectedChoices: multipleChoice,
        isMultipleChoice: multipleChoice.length === 0 ? false : true,
        targetStartDate: values.targetStartDate
          ? toUTC(values.targetStartDate).utcISOString
          : values.targetStartDate,
        targetEndDate: values.targetEndDate
          ? toUTC(values.targetEndDate).utcISOString
          : values.targetEndDate,
        plannedStartDate: values.plannedStartDate
          ? toUTC(values.plannedStartDate).utcISOString
          : values.plannedStartDate,
        plannedEndDate: values.plannedEndDate
          ? toUTC(values.plannedEndDate).utcISOString
          : values.plannedEndDate,
        actualStartDate: values.actualStartDate
          ? toUTC(values.actualStartDate).utcISOString
          : values.actualStartDate,
        actualEndDate: values.actualEndDate
          ? toUTC(values.actualEndDate).utcISOString
          : values.actualEndDate,
      };
      console.log(postData);
      await axiosPrivate
        .post(`${createLink}`, postData)
        .then((res) => {
          console.log(res);
          getTaskList();
          setTaskTypeSelect("");
          setMultipleChoice([]);
          resetForm();
          setSubmitLoading(false);
        })
        .catch((e) => {
          console.log(e, "create Task");
          setSubmitLoading(false);
        });
    }
  };
  const confirmDeleteLabour = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to delete?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDeleteLabour(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      },
    );
  };
  const confirmDeletePart = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to delete?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handlePartDelete(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      },
    );
  };
  const confirmDelete = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to delete?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDelete(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      },
    );
  };
  const handleDelete = async (id) => {
    const wotaskLink = masterAPI["workOrderTask"].delete;
    await axiosPrivate
      .delete(`${wotaskLink}/${id}`)
      .then((res) => {
        console.log(res);
        getTaskList();
        toast.success("Deleted Successfully");
      })
      .catch((e) => {
        console.log(e, "error task delete");
      });
  };
  const handleDeleteLabour = async (id) => {
    const wotaskLabour = masterAPI["workOrderTaskLabour"].delete;
    await axiosPrivate
      .delete(`${wotaskLabour}/${id}`)
      .then((res) => {
        console.log(res);
        getTaskList();
        toast.success("Deleted Successfully");
      })
      .catch((e) => {
        console.log(e, "error task delete");
      });
  };

  const listColumns = [
    {
      Header: "checkBox",
      accessor: "id",
      Cell: ({ cell }) => {
        return (
          <Checkbox
            checked={checkedList.includes(cell.row.original.id)}
            onClick={() => {
              handleChecked(cell.row.original);
            }}
          />
        );
      },
    },
    // {
    //         Header: "ID",
    //         accessor: "id",

    //     },
    {
      Header: "Task No",
      accessor: "taskNo",
    },
    {
      Header: "Task Name",
      accessor: "taskName",
    },
    {
      Header: "Task Duration (HR)",
      accessor: "taskDuration",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Sequence No",
      accessor: "sequenceNo",
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={enableDisable?.task?.edit === false}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    enableDisable?.task?.edit === false
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
            <IconButton disabled={enableDisable?.task?.delete === false}>
              <DeleteOutline
                onClick={() => {
                  confirmDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    enableDisable?.task?.delete === false
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleEdit = (value) => {
    console.log(value);
    setTaskTypeSelect(value.taskTypeName);
    setMultipleChoice(
      value.listOfChoices !== undefined ? value.listOfChoices : [""],
    );
    setEdit(true);
    setCreateTask(true);
    setEditValue(value);
  };

  const handleChecked = (e) => {
    setCheckBol(false);
    if (checkedList.includes(e.id)) {
      console.log(e, "no");
      const removeList = checkedList.filter((l) => l !== e.id);
      setCheckedList(removeList);
      const removeDetail = checkedDetail.filter((l) => l.id !== e.id);
      setCheckedDetail(removeDetail);
    } else {
      console.log("yes");
      setCheckedList([...checkedList, e.id]);
      setCheckedDetail([...checkedDetail, e]);
    }
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckBol(true);
      const gettaskId = [];
      for (let i = 0; taskData.length > i; i++) {
        console.log(taskData[i]);
        gettaskId.push(taskData[i].id);
      }
      setCheckedDetail(taskData);
      setCheckedList(gettaskId);
    } else {
      setCheckBol(false);
      setCheckedList([]);
      setCheckedDetail([]);
    }
  };

  const convertToHHMM = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  const initialValue = {
    taskName: edit ? editValue.taskName : "",
    taskNo: edit ? editValue.taskNo : "",
    sequenceNo: edit ? editValue.sequenceNo : "",
    description: edit ? editValue.description : "",
    taskDuration: edit ? convertToHHMM(editValue.taskDuration) : "",
    taskTypeId: edit ? editValue.taskTypeId : "",
    actualStartDate: edit
      ? editValue.actualStartDate
        ? fromUTC(editValue.actualStartDate).tzString
        : null
      : null,
    actualEndDate: edit
      ? editValue.actualEndDate
        ? fromUTC(editValue.actualEndDate).tzString
        : null
      : null,
    targetStartDate: edit
      ? editValue.targetStartDate !== null &&
        editValue.targetStartDate !== undefined
        ? fromUTC(editValue.targetStartDate)?.dayjsObject
        : null
      : comDetail.targetStartDate !== null &&
          comDetail.targetStartDate !== undefined
        ? fromUTC(comDetail.targetStartDate)?.dayjsObject
        : null,
    targetEndDate: edit
      ? editValue.targetEndDate !== null &&
        editValue.targetEndDate !== undefined
        ? fromUTC(editValue.targetEndDate)?.dayjsObject
        : null
      : comDetail.targetEndDate !== null &&
          comDetail.targetEndDate !== undefined
        ? fromUTC(comDetail.targetEndDate)?.dayjsObject
        : null,
    plannedStartDate: edit
      ? editValue.plannedStartDate
        ? fromUTC(editValue.plannedStartDate).tzString
        : null
      : null,
    plannedEndDate: edit
      ? editValue.plannedEndDate
        ? fromUTC(editValue.plannedEndDate).tzString
        : null
      : null,
    workOrderId: workOrderId,
    meterId: edit ? editValue.meterId : null,
  };

  const handleLabourClose = () => {
    setLabour(false);
    setCheckedDetail([]);
    setCheckedList([]);
    refreshEnableDisable();
    getTaskList();
  };

  const handlePartClose = () => {
    setPart(false);
    setCheckedDetail([]);
    setCheckedList([]);
    getTaskList();
  };

  const handlePartEditClose = () => {
    setPartEdit(false);
    setPartEditData({});
    getTaskList();
  };

  const handlePartDelete = async (id) => {
    const partDelLink = masterAPI["workOrderTaskPart"].delete;
    await axiosPrivate
      .delete(`${partDelLink}/${id}`)
      .then((res) => {
        console.log(res);
        getTaskList();
      })
      .catch((e) => {
        console.log(e, "delete part error");
      });
  };
  const handlePartEdit = (value) => {
    setPartEdit(true);
    setPartEditData(value);
  };
  const labourSortingData = labourList.sort((a, b) => a.taskNo - b.taskNo);
  const labourListColumn = [
    {
      Header: "Task No",
      accessor: "taskNo",
    },
    {
      Header: "Craft",
      accessor: "craftName",
    },
    {
      Header: "Labour",
      accessor: "labourName",
    },
    {
      Header: "Business",
      accessor: "businessName",
    },
    {
      Header: "Qty",
      accessor: "quantity",
    },

    {
      Header: "Planned Hours",
      accessor: "plannedHours",
    },
    {
      Header: "Rate",
      accessor: "rate",
      Cell: ({ cell }) => (
        <>
          {siteInfoDetail.currencySymbol}
          {cell.value}
        </>
      ),
    },
    {
      Header: "Planned Line Cost",
      accessor: "cost",
      Cell: ({ cell }) => (
        <>
          {siteInfoDetail.currencySymbol}
          {cell.value}
        </>
      ),
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ({ cell }) => (
        <IconButton
          disabled={enableDisable?.labour?.delete === false}
          onClick={() => confirmDeleteLabour(cell.value)}
        >
          <DeleteOutline
            sx={{
              color:
                enableDisable?.labour?.delete === false ? "default" : "grey",
            }}
          />
        </IconButton>
      ),
    },
  ];
  const partSortData = partList.sort((a, b) => a.taskNo - b.taskNo);
  const partsColumns = [
    {
      Header: "Task No",
      accessor: "taskNo",
      // Cell: ({ cell }) => {
      //   return (
      //    <Typography sx={{

      //             color: "#0d6efd",
      //             fontSize:"inherit",
      //             fontWeight:600

      //           }}

      //     >
      //       {cell.value}
      //     </Typography>
      //   );
      // },
    },
    // {
    //   Header: "Part ID",
    //   accessor: "partId",
    // },
    {
      Header: "Part Name",
      accessor: "partName",
    },
    {
      Header: "Planned Qty",
      accessor: "quantity",
    },
    {
      Header: "Unit Cost",
      accessor: "standardPrice",
      Cell: ({ cell }) => (
        <>
          {siteInfoDetail.currencySymbol}
          {cell.value}
        </>
      ),
    },
    {
      Header: "Planned Line Cost",
      accessor: "plannedCost",
      Cell: ({ cell }) => (
        <>
          {siteInfoDetail.currencySymbol}
          {cell.value}
        </>
      ),
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={enableDisable?.part?.edit === false}>
              <EditOutlined
                onClick={() => {
                  handlePartEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    enableDisable?.part?.edit === false
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
            {/* <IconButton>
                        <DeleteOutline
                          onClick={() => {
                            handlePartDelete(cell.row.original.id);
                          }}
                          sx={{
                            fontSize: color.masterEditDelButton,
                            color: color.masterEditDelButtonColor,
                          }}
                        /> 
                      </IconButton> */}
            <IconButton
              disabled={enableDisable?.part?.delete === false}
              onClick={() => confirmDeletePart(cell.row.original.id)}
            >
              <DeleteOutline
                sx={{
                  color:
                    enableDisable?.part?.delete === false ? "default" : "grey",
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleRemoveItem = (index) => {
    const newItems = [...multipleChoice];
    newItems.splice(index, 1);
    setMultipleChoice(newItems);
  };

  const validationSchema = Yup.object({
    taskDuration: Yup.string()
      .required("This field is required")
      .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
  });

  const convertToHours = (time) => {
    if (!time) return 0;

    const [hours, minutes] = time.split(":").map(Number);

    return hours + minutes / 60;
  };

  return (
    <Box>
      {loading ? (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container gap={"1rem"}>
            <Grid
              item
              xs={12}
              sx={{
                boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                p: 1.5,
                backgroundColor: "white",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "0.75rem",
                  mb: "0.5rem",
                }}
              >
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: { xs: "0.95rem", sm: color.masterDialogFontSize },
                    fontWeight: 600,
                  }}
                >
                  Task List
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: { xs: "0.25rem", sm: "0.5rem" },
                  }}
                >
                  {/* <Box sx={{display:"flex",alignItems:"center",gap:"1rem"}}>
              <Typography>Source:</Typography>
                <Select size="small" fullWidth value={source} onChange={(e)=>{setSource(e.target.value)}} sx={{width:"10vw"}} >
                  <MenuItem value="eam">EAM</MenuItem>
                  <MenuItem value="syspro">SysPro</MenuItem>
                </Select>
                </Box> */}
                  <Tooltip title="Labour">
                    <span>
                      <IconButton
                        size="small"
                        disabled={
                          checkedList.length === 0 ||
                          enableDisable?.labour?.create === false
                        }
                        onClick={() => {
                          setLabour(true);
                        }}
                      >
                        <GroupAdd sx={{ fontSize: { xs: "1.4rem", sm: "1.7rem" } }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Parts">
                    <span>
                      <IconButton
                        size="small"
                        disabled={
                          checkedList.length === 0 ||
                          enableDisable?.part?.create === false
                        }
                        onClick={() => {
                          setPart(true);
                        }}
                      >
                        <Domain sx={{ fontSize: { xs: "1.4rem", sm: "1.7rem" } }} />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip title="Task">
                    <Box
                      sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                      onClick={() => {
                        if (enableDisable?.task?.create !== false) handleAddTask();
                      }}
                    >
                      <IconButton
                        size="small"
                        disabled={enableDisable?.task?.create === false}
                      >
                        <LibraryAdd sx={{ fontSize: { xs: "1.4rem", sm: "1.7rem" } }} />
                      </IconButton>
                      <Typography
                        sx={{
                          fontSize: { xs: "0.85rem", sm: "1rem" },
                          display: { xs: "none", sm: "block" },
                        }}
                      >
                        Task
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
              </Box>
              <Divider
                sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
              />

              <NormalTable
                columns={listColumns}
                data={taskData}
                handleCheckAll={handleCheckAll}
                checkBol={checkBol}
              />
              {/* <NormalTableEdit columns={listColumns} data={taskData} handleEditValue={handleEditValue} /> */}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                p: 1.5,
                backgroundColor: "white",
                display: taskCreate ? "grid" : "none",
              }}
            >
              <Formik
                initialValues={initialValue}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
                // innerRef={formikRef}
                enableReinitialize
              >
                {({
                  handleChange,
                  setFieldValue,
                  values,
                  resetForm,
                  errors,
                }) => (
                  <Form>
                    <Grid container spacing={"1.5rem"}>
                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            color: color.masterDialogTitleColor,
                            fontSize: color.masterDialogFontSize,
                          }}
                        >
                          {edit ? "Edit Task" : " Create Task"}
                        </Typography>
                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Task No
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="taskNo"
                          placeholder="Enter Task No"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Task Name
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="taskName"
                          placeholder="Enter Task Name"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Task Duration
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="taskDuration"
                          placeholder="Enter Task Duration (HH:MM)"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                        <ErrorMessage name="taskDuration">
                          {(error) => <ErrorProps>{error}</ErrorProps>}
                        </ErrorMessage>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Task Type
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="taskTypeId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.taskTypeId !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {taskTypeList.map((id, i) => (
                            <MenuItem
                              value={id.value}
                              onClick={() => {
                                setTaskTypeSelect(id.text);
                                if (
                                  id.text.toLowerCase() === "multiple choice"
                                ) {
                                  setMultipleChoice([""]);
                                }
                              }}
                            >
                              {id.text}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display:
                            taskTypeSelect.toLowerCase() === "meter reading"
                              ? "default"
                              : "none",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Meter
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="meterId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.meterId !== null
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {meter.map((id, i) => (
                            <MenuItem value={id.meterId}>
                              {id.meterName}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display:
                            taskTypeSelect.toLowerCase() === "multiple choice"
                              ? "default"
                              : "none",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            Choice
                          </Typography>

                          <Add
                            sx={{ cursor: "pointer", color: color.labelColor }}
                            onClick={() => {
                              setMultipleChoice([...multipleChoice, ""]);
                            }}
                          />
                        </Box>

                        <Grid item xs={12}>
                          {multipleChoice.map((choice, i) => (
                            <Box
                              sx={{
                                display: "flex",
                                gap: "0.2rem",
                                width: "100%",
                              }}
                            >
                              <Field
                                as={TextField}
                                size={"small"}
                                type="text"
                                value={choice}
                                placeholder="Enter Choice"
                                fullWidth
                                onChange={(e) => {
                                  const mcData = [...multipleChoice];
                                  mcData[i] = e.target.value;
                                  console.log(mcData);
                                  setMultipleChoice(mcData);
                                }}
                                sx={{
                                  ".MuiInputBase-input": {
                                    // letterSpacing: "0.2rem",

                                    "&::placeholder": {
                                      // color: "green",
                                      opacity: 1,
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    },
                                  },
                                }}
                              />
                              <IconButton
                                onClick={() => {
                                  if (multipleChoice.length !== 1) {
                                    handleRemoveItem(i);
                                  }
                                }}
                              >
                                <DeleteOutline />
                              </IconButton>
                            </Box>
                          ))}
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Sequence No
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="sequenceNo"
                          placeholder="Enter Sequence No"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            color: color.masterDialogTitleColor,
                            fontSize: color.masterDialogFontSize,
                          }}
                        >
                          {" "}
                          Details{" "}
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                          >
                            {open ? <ArrowDropUp /> : <ArrowDropDown />}
                          </IconButton>
                        </Typography>
                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                        <Collapse in={open} timeout="auto" unmountOnExit>
                          <Grid container spacing={"1.5rem"}>
                            <Grid item xs={12} sm={6} mb={2}>
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Description
                              </Typography>
                              <Field
                                as={TextField}
                                size={"small"}
                                type="text"
                                name="description"
                                placeholder="Enter Description"
                                fullWidth
                                sx={{
                                  ".MuiInputBase-input": {
                                    // letterSpacing: "0.2rem",

                                    "&::placeholder": {
                                      // color: "green",
                                      opacity: 1,
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    },
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={"1.5rem"}>
                            <Grid
                              item
                              xs={12} sm={6}
                              sx={{
                                ".css-1pduc5x-MuiStack-root": {
                                  paddingTop: 0,
                                  overflowX: { xs: "auto", lg: "hidden" },
                                  overflowY: "hidden",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Target Start Date
                              </Typography>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DateTimePicker"]}>
                                  <DateTimePicker
                                    format="DD/MM/YYYY HH:mm"
                                    ampm={false}
                                    value={dayjs(values.targetStartDate)}
                                    // sx={{".css-1xhypcz-MuiStack-root":{
                                    //   padding:0
                                    // }}}

                                    readOnly
                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        margin: "-8px 0 0 0",
                                        fullWidth: true,
                                      },
                                    }}
                                    onChange={(newValue) => {
                                      console.log(newValue);
                                      if (newValue !== null) {
                                        if (
                                          `${newValue.$d}` !== "Invalid Date"
                                        ) {
                                          const dateFrom =
                                            getDateWithOutUTC(newValue);
                                          setFieldValue(
                                            "targetStartDate",
                                            dateFrom,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Grid>

                            <Grid
                              item
                              xs={12} sm={6}
                              sx={{
                                ".css-1pduc5x-MuiStack-root": {
                                  paddingTop: 0,
                                  overflowX: { xs: "auto", lg: "hidden" },
                                  overflowY: "hidden",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Target End Date
                              </Typography>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DateTimePicker"]}>
                                  <DateTimePicker
                                    format="DD/MM/YYYY HH:mm"
                                    ampm={false}
                                    value={dayjs(values.targetEndDate)}
                                    // sx={{".css-1xhypcz-MuiStack-root":{
                                    //   padding:0
                                    // }}}
                                    readOnly
                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        margin: "-8px 0 0 0",
                                        fullWidth: true,
                                      },
                                    }}
                                    fullWidth
                                    onChange={(newValue) => {
                                      console.log(newValue);
                                      if (newValue !== null) {
                                        if (
                                          `${newValue.$d}` !== "Invalid Date"
                                        ) {
                                          const dateFrom =
                                            getDateWithOutUTC(newValue);
                                          setFieldValue(
                                            "targetEndDate",
                                            dateFrom,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Grid>
                            <Grid
                              item
                              xs={12} sm={6}
                              sx={{
                                ".css-1pduc5x-MuiStack-root": {
                                  paddingTop: 0,
                                  overflowX: { xs: "auto", lg: "hidden" },
                                  overflowY: "hidden",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Planned Start Date
                              </Typography>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DateTimePicker"]}>
                                  <DateTimePicker
                                    ampm={false}
                                    format="DD/MM/YYYY HH:mm"
                                    viewRenderers={{
                                      hours: renderTimeViewClock,
                                      minutes: renderTimeViewClock,
                                      seconds: renderTimeViewClock,
                                    }}
                                    value={
                                      values.plannedStartDate !== null
                                        ? dayjs(values.plannedStartDate)
                                        : values.plannedStartDate
                                    }
                                    // sx={{".css-1xhypcz-MuiStack-root":{
                                    //   padding:0
                                    // }}}

                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        margin: "-8px 0 0 0",
                                        fullWidth: true,
                                      },
                                    }}
                                    fullWidth
                                    onChange={(newValue) => {
                                      console.log(newValue);
                                      if (newValue !== null) {
                                        if (
                                          `${newValue.$d}` !== "Invalid Date"
                                        ) {
                                          const dateFrom =
                                            getDateWithOutUTC(newValue);
                                          setFieldValue(
                                            "plannedStartDate",
                                            dateFrom,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Grid>
                            <Grid
                              item
                              xs={12} sm={6}
                              sx={{
                                ".css-1pduc5x-MuiStack-root": {
                                  paddingTop: 0,
                                  overflowX: { xs: "auto", lg: "hidden" },
                                  overflowY: "hidden",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Planned End Date
                              </Typography>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DateTimePicker"]}>
                                  <DateTimePicker
                                    ampm={false}
                                    format="DD/MM/YYYY HH:mm"
                                    viewRenderers={{
                                      hours: renderTimeViewClock,
                                      minutes: renderTimeViewClock,
                                      seconds: renderTimeViewClock,
                                    }}
                                    value={
                                      values.plannedEndDate !== null
                                        ? dayjs(values.plannedEndDate)
                                        : values.plannedEndDate
                                    }
                                    // sx={{".css-1xhypcz-MuiStack-root":{
                                    //   padding:0
                                    // }}}

                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        margin: "-8px 0 0 0",
                                        fullWidth: true,
                                      },
                                    }}
                                    fullWidth
                                    onChange={(newValue) => {
                                      console.log(newValue);
                                      if (newValue !== null) {
                                        if (
                                          `${newValue.$d}` !== "Invalid Date"
                                        ) {
                                          const dateFrom =
                                            getDateWithOutUTC(newValue);
                                          setFieldValue(
                                            "plannedEndDate",
                                            dateFrom,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Grid>
                            <Grid
                              item
                              xs={12} sm={6}
                              sx={{
                                ".css-1pduc5x-MuiStack-root": {
                                  paddingTop: 0,
                                  overflowX: { xs: "auto", lg: "hidden" },
                                  overflowY: "hidden",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Actual Start Date
                              </Typography>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DateTimePicker"]}>
                                  <DateTimePicker
                                    ampm={false}
                                    format="DD/MM/YYYY HH:mm"
                                    viewRenderers={{
                                      hours: renderTimeViewClock,
                                      minutes: renderTimeViewClock,
                                      seconds: renderTimeViewClock,
                                    }}
                                    readOnly
                                    disableOpenPicker
                                    value={
                                      values.actualStartDate !== null
                                        ? dayjs(values.actualStartDate)
                                        : values.actualStartDate
                                    }
                                    // sx={{".css-1xhypcz-MuiStack-root":{
                                    //   padding:0
                                    // }}}

                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        margin: "-8px 0 0 0",
                                        fullWidth: true,
                                        InputProps: {
                                          endAdornment: null,
                                        },
                                      },
                                    }}
                                    fullWidth
                                    onChange={(newValue) => {
                                      console.log(newValue);
                                      if (newValue !== null) {
                                        if (
                                          `${newValue.$d}` !== "Invalid Date"
                                        ) {
                                          const dateFrom =
                                            getDateWithOutUTC(newValue);
                                          setFieldValue(
                                            "actualStartDate",
                                            dateFrom,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Grid>
                            <Grid
                              item
                              xs={12} sm={6}
                              sx={{
                                ".css-1pduc5x-MuiStack-root": {
                                  paddingTop: 0,
                                  overflowX: { xs: "auto", lg: "hidden" },
                                  overflowY: "hidden",
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: color.labelFontWeight,
                                  mb: color.labelmb,
                                  fontSize: color.labelFont,
                                  color: color.labelColor,
                                }}
                              >
                                Actual End Date
                              </Typography>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DateTimePicker"]}>
                                  <DateTimePicker
                                    ampm={false}
                                    format="DD/MM/YYYY HH:mm"
                                    viewRenderers={{
                                      hours: renderTimeViewClock,
                                      minutes: renderTimeViewClock,
                                      seconds: renderTimeViewClock,
                                    }}
                                    readOnly
                                    disableOpenPicker
                                    value={
                                      values.actualEndDate !== null
                                        ? dayjs(values.actualEndDate)
                                        : values.actualEndDate
                                    }
                                    // sx={{".css-1xhypcz-MuiStack-root":{
                                    //   padding:0
                                    // }}}

                                    slotProps={{
                                      textField: {
                                        size: "small",
                                        margin: "-8px 0 0 0",
                                        fullWidth: true,
                                        InputProps: {
                                          endAdornment: null,
                                        },
                                      },
                                    }}
                                    fullWidth
                                    onChange={(newValue) => {
                                      console.log(newValue);
                                      if (newValue !== null) {
                                        if (
                                          `${newValue.$d}` !== "Invalid Date"
                                        ) {
                                          const dateFrom =
                                            getDateWithOutUTC(newValue);
                                          setFieldValue(
                                            "actualEndDate",
                                            dateFrom,
                                          );
                                        }
                                      }
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Grid>
                          </Grid>
                        </Collapse>
                      </Grid>
                      <Grid container item xs={12} justifyContent={"flex-end"}>
                        <Button
                          onClick={() => {
                            setCreateTask(false);
                            setEdit(false);
                            setEditValue({});
                          }}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" disabled={submitLoading}>
                          {submitLoading ? (
                            <CircularProgress size={20} />
                          ) : (
                            "submit"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                p: 1.5,
                backgroundColor: "white",
              }}
            >
              <Typography
                sx={{
                  color: color.masterDialogTitleColor,
                  fontSize: color.masterDialogFontSize,
                }}
              >
                {" "}
                Labour{" "}
              </Typography>
              <Divider
                sx={{
                  border: "1px solid rgb(0 0 0 / 17%)",
                  mb: "15px",
                  mt: "5px",
                }}
              />

              <NormalTable
                data={labourSortingData}
                columns={labourListColumn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                p: 1.5,
                backgroundColor: "white",
              }}
            >
              <Typography
                sx={{
                  color: color.masterDialogTitleColor,
                  fontSize: color.masterDialogFontSize,
                }}
              >
                {" "}
                Part{" "}
              </Typography>
              <Divider
                sx={{
                  border: "1px solid rgb(0 0 0 / 17%)",
                  mb: "15px",
                  mt: "5px",
                }}
              />
              <NormalTable data={partSortData} columns={partsColumns} />
            </Grid>
            <ResponsiveDialog
              open={labour}
              onClose={handleLabourClose}
              fullWidth
              maxWidth={"lg"}
              children={
                workCenterIdList.length > 0 ? (
                  <LabourBusinessCraft
                    handleCloseClick={handleLabourClose}
                    type={"wot"}
                    woId={workOrderId}
                    taskData={checkedList}
                    dataDetail={checkedDetail}
                    woDetail={comDetail}
                  />
                ) : (
                  <Labour
                    handleCloseClick={handleLabourClose}
                    type={"wot"}
                    woId={workOrderId}
                    taskData={checkedList}
                    dataDetail={checkedDetail}
                  />
                )
              }
            />
            <ResponsiveDialog
              open={part}
              onClose={handlePartClose}
              fullWidth
              maxWidth={"lg"}
              children={
                <PartList
                  handleCloseClick={handlePartClose}
                  type={"wot"}
                  source={source}
                  taskData={checkedList}
                  dataDetail={checkedDetail}
                  jobNo={comDetail.notes}
                />
              }
            />
            <ResponsiveDialog
              open={partEdit}
              onClose={handlePartEditClose}
              fullWidth
              maxWidth={"md"}
              children={
                <PartEdit
                  handleCloseClick={handlePartEditClose}
                  type={"wo"}
                  editData={partEditData}
                />
              }
            />
          </Grid>
          {/* )} */}
        </>
      )}
    </Box>
  );
};

export default WorkPlan;
